import Thermometer from './Thermometer';
import { ThermometerBox } from './Thermometer.style';

export default Thermometer;
export { ThermometerBox };
